var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-progress"},[_c('canvas',{style:({ width: _vm.width + 'px', height: _vm.height + 'px' }),attrs:{"id":"canvas","width":_vm.width,"height":_vm.height}}),_c('div',{staticClass:"progress-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }